import { createQueryKeys } from '@lukemorales/query-key-factory';
import type {
  GetLikedProductsServiceRequest,
  GetPopularProductsServiceRequest,
  SearchProductsServiceRequest,
} from '@musinsa/services-curator';
import {
  getLikedProductsService,
  getPopularProductsService,
  searchProductsService,
} from '@musinsa/services-curator';

export const productsFactory = createQueryKeys('products', {
  liked: (params: Omit<GetLikedProductsServiceRequest, 'page'>) => ({
    queryKey: [{ params }],
    queryFn: ({ pageParam = 1 }: { pageParam?: number }) =>
      getLikedProductsService({ ...params, page: pageParam }),
  }),

  search: (params: Omit<SearchProductsServiceRequest, 'page'>) => ({
    queryKey: [{ params }],
    queryFn: ({ pageParam = 1 }: { pageParam?: number }) =>
      searchProductsService({ ...params, page: pageParam }),
  }),

  popular: (params: GetPopularProductsServiceRequest) => ({
    queryKey: [{ params }],
    queryFn: () => getPopularProductsService(params),
  }),
});
